var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "booking-form",
    {
      ref: "form",
      attrs: {
        "property-mutator": _vm.propertyMutator,
        "in-person-opportunity-options": _vm.inPersonOpportunityOptions,
        "online-opportunity-options": _vm.onlineOpportunityOptions,
        "category-options": _vm.categoryOptions,
        booking: _vm.booking,
        duplicated: _vm.duplicated,
        validationTriggered: _vm.validationTriggered,
        "additional-departments": _vm.additionalDepartments,
      },
    },
    [
      _c(
        "template",
        { slot: "shortlist" },
        [
          _vm._t("shortlist-parent", function () {
            return [
              _c("request-shortlist", { attrs: { booking: _vm.booking } }),
            ]
          }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }